import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const resetUserPassword = createApiThunk<void, { email: string }>(
  "users/resetUserPassword",
  async (body, { extra: { publicRepository } }) => {
    return publicRepository!.resetPassword(body);
  },
);

export const resetResetUserPassword = createAction("users/resetResetUserPassword");
